import { render, staticRenderFns } from "./authorizationTitle.vue?vue&type=template&id=4f5a4a52&"
import script from "./authorizationTitle.vue?vue&type=script&lang=js&"
export * from "./authorizationTitle.vue?vue&type=script&lang=js&"
import style0 from "./authorizationTitle.vue?vue&type=style&index=0&id=4f5a4a52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports